import axios from 'axios';
import { CORE_API } from '../env.config';

const fetchConsentAgreement = async (coreTokenObject, language) => {
  const { token } = coreTokenObject;
  const baseURL = CORE_API;
  const coreConfig = {
    baseURL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(`consent_agreements?filter%5Bstate%5D=active&%5Blanguage%5D=${language}`, coreConfig);

  const consentAgreement = response.data.data[0].attributes;

  return consentAgreement;
};

export default fetchConsentAgreement;
